import React, { MouseEvent, ReactNode, useState } from 'react'

import { RiAlertLine, RiCheckboxCircleLine, RiCloseLine, RiErrorWarningLine, RiInformation2Line } from 'react-icons/ri'

export type AlertProps = {
  alertActions?: ReactNode
  description?: string
  dismissible?: boolean
  message: string | ReactNode
  onClose?: () => void
  type: string
}

export default function Alert({ alertActions, description, dismissible, message, onClose, type }: AlertProps) {
  const [hide, setHide] = useState(false)

  if (!type || !message) return null

  const alertTypes: { [key: string]: { alertClass: string; icon: ReactNode } } = {
    error: { alertClass: 'alert-error border-error', icon: <RiErrorWarningLine className="h-6 w-6" /> },
    success: {
      alertClass: 'alert-success border-success',

      icon: <RiCheckboxCircleLine className="h-6 w-6" />,
    },
    warning: {
      alertClass: 'alert-warning border-warning',

      icon: <RiAlertLine className="h-6 w-6" />,
    },
    info: { alertClass: 'alert-info border-info', icon: <RiInformation2Line className="h-6 w-6" /> },
  }

  const handleClose = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (onClose) {
      onClose()
    }
    setHide(true)
  }

  const { alertClass, icon } = alertTypes[type] || alertTypes.error

  return (
    <>
      {dismissible && hide ? (
        <></>
      ) : (
        <div role="alert" className={`alert alert-vertical alert-soft sm:alert-horizontal ${alertClass} m-4 p-4`}>
          {icon && <span>{icon}</span>}
          <div>
            <h3 className="font-bold">{message}</h3>
            <div className="text-xs">{description}</div>
          </div>
          {alertActions && <div className="flex items-center">{alertActions}</div>}
          {dismissible && (
            <button aria-label="Close" className="btn btn-ghost btn-sm" onClick={handleClose}>
              <RiCloseLine className="h-6 w-6" />
            </button>
          )}
        </div>
      )}
    </>
  )
}

export { Alert }
